import { render, staticRenderFns } from "./CreateIssue.vue?vue&type=template&id=51ffc856&scoped=true&"
import script from "./CreateIssue.vue?vue&type=script&lang=js&"
export * from "./CreateIssue.vue?vue&type=script&lang=js&"
import style0 from "./CreateIssue.vue?vue&type=style&index=0&id=51ffc856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffc856",
  null
  
)

export default component.exports